"use client";

import Link from "next/link";
import { useEffect } from "react";
import { usePathname } from "next/navigation";

export default function HelpError(props: { error: Error & { digest?: string }; reset: () => void }) {
  const { error, reset } = props;
  const pathname = usePathname() ?? "";
  const locale = pathname.split("/")[1] || "en";

  useEffect(() => {
    console.error("Help page rendering failed:", error);
  }, [error]);

  return (
    <section className="min-h-screen bg-[#f4efe3] px-4 pb-16 pt-28 md:pb-24">
      <div className="container max-w-[50rem] rounded-2xl border border-[#d8cab2] bg-[#fffaf1] p-6">
        <h1 className="text-2xl font-semibold text-[#1f2a27]">Unable to load Help Center</h1>
        <p className="mt-2 text-sm text-[#4a5d57]">Please retry. If the issue continues, send a support request.</p>
        <div className="mt-5 flex flex-wrap items-center gap-3">
          <button
            type="button"
            onClick={() => reset()}
            className="inline-flex min-h-11 items-center justify-center rounded-xl border border-[#0f766e]/30 bg-[#0f766e] px-4 text-sm font-semibold text-white transition-colors hover:bg-[#0d6860]"
          >
            Try again
          </button>
          <Link
            href={`/${locale}/help/contact`}
            className="inline-flex min-h-11 items-center justify-center rounded-xl border border-[#d7cab1] bg-[#fffaf1] px-4 text-sm font-semibold text-[#32453f] transition-colors hover:bg-[#fbf6eb]"
          >
            Contact support
          </Link>
        </div>
      </div>
    </section>
  );
}
